module.exports = __webpack_public_path__ + "img/income.105e7a4b.svg";